/**
 * Тексты карточек How development happens. Менять копирайт здесь, не в JSX.
 */

export const PROCESS_COPY = {
    titleLines: ["How development", "happens"],
};

export const PROCESS_STEPS = [
    {
        number: "1",
        title: "Order a website",
        text: "We analyze the market and get acquainted with your business. Our manager identifies the specifics and key pain points of your industry to create a plan for building a maximally productive website.",
    },
    {
        number: "2",
        title: "Solution",
        text: "Development of a technical specification for the project, defining the core functionality of the website and outlining all stages of work.",
    },
    {
        number: "3",
        title: "Design Development",
        text: "Development of the site layout and website design taking into account the set tasks. We will think through all the necessary functions and 'features' for the future website.",
    },
    {
        number: "4",
        title: "Website Technical Build",
        text: "\"Fitting\" the layout (website design) onto a content management system (CMS), programming of modules and website functionality according to the technical specification (TS).",
    },
    {
        number: "5",
        title: "Testing",
        text: "Bug detection, analysis of website performance under high loads and virus attacks, checking website display across different browsers and systems.",
    },
    {
        number: "6",
        title: "Launch",
        text: "After the website is created and filled with content, we transfer it to hosting and connect it to your domain. This is just the beginning — the next stage involves promotion, advertising, and SEO optimization of the website.",
    },
];

// config/process.js
